import { MapLocationGeneratedEntity } from "./generated/MapLocationGeneratedEntity";

export abstract class MapLocationEntity extends MapLocationGeneratedEntity {
    // Comment to preserve new line
}
